import React, { useState } from 'react'
import Sidebar from '../components/sidebar/Sidebar'
import { Route, Routes } from 'react-router-dom'
import Home from './Home'
import Header from '../components/Header'
import Product from './Product'
import CreateProduct from './CreateProduct'
import ProtectedRoute from '../utils/ProtectedRoute'
import EditProduct from './EditProduct'
import ViewProduct from './ViewProduct'
import Category from './Category'
import Coupons from './Coupons'
import Orders from './Orders'
import ViewOrder from './ViewOrder'
import Customers from './Customers'
import CustomersPage from './CustomersPage'
import StoreCustomisation from './StoreCustomisation'
import Staffs from './Staffs'
import Setting from './Setting'
import OurShop from './OurShop'
import SubCategory from './SubCategory'

function Dashboard() {

    const [isHide, setisHide] = useState(false)

    const handleIsHide = () => {
        setisHide(!isHide)
    }


    return (
        <div className='relative w-full flex overflow-hidden'>
            {/* Sidebar */}
            {!isHide && (
                <div className="fixed left-0 top-0 w-64 h-screen overflow-y-hidden" >
                    <Sidebar />
                </div>
            )}

            {/* Main */}
            <div
                className="w-full ml-64 transition delay-200 space-y-10 relative pb-8"
                style={{ marginLeft: isHide ? 0 : '256px' }}
            >
                <div className="sticky top-0 z-[1111]">
                    <Header callback={handleIsHide} />
                </div>

                <div className="w-full px-7">
                    <Routes>
                        <Route path='/' element={
                            <ProtectedRoute>
                                <Home />
                            </ProtectedRoute>
                        }
                        />

                        <Route path='/our-shop' element={
                            <ProtectedRoute>
                                <OurShop />
                            </ProtectedRoute>
                        }
                        />

                        <Route path='/products' element={
                            <ProtectedRoute>
                                <Product />
                            </ProtectedRoute>}
                        />

                        <Route path='/products/new' element={
                            <ProtectedRoute>
                                <CreateProduct />
                            </ProtectedRoute>
                        }
                        />

                        <Route path='/products/:slug/view' element={
                            <ProtectedRoute>
                                <ViewProduct />
                            </ProtectedRoute>
                        } />

                        <Route path='/products/edit/:slug' element={
                            <ProtectedRoute>
                                <EditProduct />
                            </ProtectedRoute>
                        } />

                        <Route path='/category' element={
                            <ProtectedRoute>
                                <Category />
                            </ProtectedRoute>
                        } />

                        <Route path='/category/:id' element={
                            <ProtectedRoute>
                                <SubCategory />
                            </ProtectedRoute>
                        } />


                        <Route path='/coupons' element={
                            <ProtectedRoute>
                                <Coupons />
                            </ProtectedRoute>
                        } />

                        <Route path='/orders' element={
                            <ProtectedRoute>
                                <Orders />
                            </ProtectedRoute>
                        } />

                        <Route path='/orders/:id' element={
                            <ProtectedRoute>
                                <ViewOrder />
                            </ProtectedRoute>
                        } />

                        <Route path='/customers' element={
                            <ProtectedRoute>
                                <Customers />
                            </ProtectedRoute>
                        } />

                        <Route path='/customers/:id' element={
                            <ProtectedRoute>
                                <CustomersPage />
                            </ProtectedRoute>
                        } />

                        <Route path='/settings' element={
                            <ProtectedRoute>
                                <Setting />
                            </ProtectedRoute>
                        } />

                        <Route path='/staffs' element={
                            <ProtectedRoute>
                                <Staffs />
                            </ProtectedRoute>
                        } />

                        <Route path='/store/customisation' element={
                            <ProtectedRoute>
                                <StoreCustomisation />
                            </ProtectedRoute>
                        } />
                    </Routes>
                </div>
            </div>
        </div>
    )
}

export default Dashboard